import repo from "./repository";
import courses from "./repositories/courseRepository";
import day from "./repositories/dayRepository";
import admin from "./repositories/adminRepository";
import delivery from "./repositories/deliveryRepository";
import analyst from "./repositories/analystRepository";
import user from "./repositories/userRepository";
import organization from "./repositories/organizationRepository";

import analytics from "./repositories/analyticsRepository";
import invite from "./repositories/inviteRepository";

import imageRepo from "./repositories/imageRepository";
const draftRepo = courses({ repository: repo });
const writerRepo = day({ repository: repo });

import paymentMethods from "./repositories/billing/paymentMethods";
import subscriptions from "./repositories/billing/subscriptionRepository";
import accounts from "./repositories/billing/accountDetails";
import apikeys from "./repositories/apiKeys";
import jsonimport from "./repositories/bulkEnrollments";
export default {
  user,
  course: draftRepo,
  day: writerRepo,
  image: imageRepo(repo),
  admin: admin({ repository: repo }),
  delivery: delivery({ repository: repo }),
  analytics: analyst({ repository: repo }),
  organization,
  metrics: analytics({ repository: repo }),
  invite: invite({ repository: repo }),
  apikeys: apikeys({ repository: repo }),
  enrollments: {
    json: jsonimport({ repository: repo })
  },
  billing: {
    paymentMethods: paymentMethods({ repository: repo }),
    subscriptions: subscriptions({ repository: repo }),
    accounts: accounts({ repository: repo })
  }
};
